"use client";
import { motion } from "framer-motion";
import { Container, SectionSubHeading } from "@/components";
import { caseStudyMethod } from "@/data/CaseStudyPageData";
import { fadeInUp } from "@/lib/animation/variant";

const CaseStudyMethod = () => {
  return (
    <section className="mt-16 w-full rounded-4xl bg-accent-foreground py-16 text-white md:mt-24 md:py-24">
      <Container className="flex flex-col gap-6 px-4 lg:px-10">
        <motion.div
          custom={0}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <SectionSubHeading
            subtitle="How every build runs — five stages, nothing compressed"
            className="text-primary"
          />
        </motion.div>

        <div className="mt-2">
          {caseStudyMethod.map((step, index) => (
            <div
              key={step.number}
              className="relative grid items-baseline gap-3 border-b border-white/15 py-7 last:border-b-0 lg:grid-cols-[0.42fr_0.58fr] lg:gap-11"
            >
              <h3 className="text-4xl leading-[0.84] font-black tracking-tighter uppercase md:text-6xl">
                <sup className="mr-2 align-super text-[0.32em] tracking-[0.06em] text-primary">
                  {step.number}
                </sup>
                {step.title}
              </h3>
              <p className="leading-loose text-white/65">{step.description}</p>

              {/* The lime rule draws itself across the divider as the row lands. */}
              <motion.span
                aria-hidden
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{
                  duration: 0.9,
                  delay: index * 0.1,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="absolute -bottom-px left-0 h-0.5 w-full origin-left bg-primary"
              />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default CaseStudyMethod;
